import * as yup from "yup";

export const CommentSchema = yup.object().shape({
  firstName: yup.string().trim().required("First Name is required"),
  lastName: yup.string().trim().optional(),
  comment: yup.string().trim().required("comment is required"),
  phone: yup.string().trim().optional(),
  email: yup.string().trim().email().required("Email is required"),
});

export type CommentSchema = yup.InferType<typeof CommentSchema>;
